export function AccuracyV2Icon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='70' height='70' viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M35 68C53.2254 68 68 53.2254 68 35C68 16.7746 53.2254 2 35 2C16.7746 2 2 16.7746 2 35C2 53.2254 16.7746 68 35 68Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M34.9953 54.8002C45.9305 54.8002 54.7953 45.9354 54.7953 35.0002C54.7953 24.065 45.9305 15.2002 34.9953 15.2002C24.0601 15.2002 15.1953 24.065 15.1953 35.0002C15.1953 45.9354 24.0601 54.8002 34.9953 54.8002Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M35.0023 41.6001C38.6474 41.6001 41.6023 38.6452 41.6023 35.0001C41.6023 31.3551 38.6474 28.4001 35.0023 28.4001C31.3573 28.4001 28.4023 31.3551 28.4023 35.0001C28.4023 38.6452 31.3573 41.6001 35.0023 41.6001Z'
        stroke='currentColor'
        strokeWidth='3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
